import * as d3 from 'd3'

export default {

  data: () => ({
    selectedItems:    null,
    getItems:         null,
  }),

  methods: {
    set_selectedItems() {
      this.selectedItems = { 
        ...this.selectedItems,
        current: JSON.parse(JSON.stringify(this.current))
      }
    },

    draw_PDF() {
      if (this.getItems.current) {
        this.current = this.getItems.current
      }

      d3.select(`#AREA_OVERALL`).transition().duration(300).attr('opacity', .8) 
      d3.select(`#AREA_TXT_OVERALL`).transition().duration(300).attr('font-weight', 400).attr('fill', '#333')
      d3.select(`#AREA_IN_OVERALL`).transition().duration(300).attr('opacity', 0)

      d3.select(`#AREA_${this.current.area}`).transition().duration(150).attr('opacity', 1) 
      d3.select(`#AREA_TXT_${this.current.area}`).transition().duration(150).attr('font-weight', 450).attr('fill', '#000')
      d3.select(`#AREA_IN_${this.current.area}`).transition().duration(150).attr('opacity', 1)

      d3.select(`#ITRNONE`).attr('opacity', 0.8)
      d3.select(`#SHT_TXT_NONE`).attr('font-weight', 400).attr('fill', '#757575')

      d3.select(`#ITR${this.current.sheet}`).style('opacity', 1)
      d3.select(`#SHT_TXT_${this.current.sheet}`).attr('font-weight', 600).attr('fill', '#000')

      d3.select(`#SYS_SVG`).remove()

      this.reflash_Skyline() //-----> Redrawing
    },
  },

  watch: {
    selectedItems() {
      this.$emit('selectedItems', this.selectedItems)
    },
  },
  
}